import React from "react";
import { GrDocumentText } from "react-icons/gr";

import "./TestCard.scss";

export default function TestCard({ test }) {
  return (
    <div className="test_card">
      <div className="test_info">
        <div className="total_questions">20 Ques</div>
        <div className="test_title">{test.testTitle}</div>
        <div className="test_date">{test.testDate}</div>
      </div>
      <div className="test_icon">
        <GrDocumentText />
      </div>
    </div>
  );
}
